import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FileText, Eye } from 'lucide-react';
import { articles } from '../../data/articles';
import { formatDate } from '../../utils/dateFormat';
import PageTitle from '../../components/PageTitle';

export default function DashboardArticles() {
    const { t, i18n } = useTranslation('dashboard');
    const navigate = useNavigate();
    const currentLang = i18n.language.startsWith('zh') ? 'zh' : 'en';

    return (
        <div className="p-8 space-y-6">
            <PageTitle titleKey="articles.title" namespace="dashboard" descriptionKey="articles.subtitle" />
            <div>
                <h1 className="text-2xl font-semibold text-foreground tracking-tight">
                    {t('articles.title')}
                </h1>
                <p className="text-sm text-muted-foreground mt-1">
                    {t('articles.subtitle')}
                </p>
            </div>

            <div className="bg-card rounded-xl shadow-sm overflow-hidden border border-border">
                {articles.length === 0 ? (
                    <div className="p-8 text-center text-muted-foreground">
                        {t('articles.no_articles')}
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-border">
                            <thead className="bg-muted/50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                                        {t('articles.col_title')}
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                                        {t('articles.col_date')}
                                    </th>
                                    <th className="px-6 py-3 text-right text-xs font-medium text-muted-foreground uppercase tracking-wider">
                                        {t('articles.col_actions')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-card divide-y divide-border">
                                {articles.map((article) => (
                                    <tr key={article.id} className="hover:bg-muted/50 transition-colors">
                                        <td className="px-6 py-4">
                                            <div className="text-sm font-medium text-foreground">
                                                {article.title[currentLang]}
                                            </div>
                                            {currentLang === 'en' && article.title.zh && (
                                                <div className="text-xs text-muted-foreground mt-1">
                                                    {article.title.zh}
                                                </div>
                                            )}
                                            {currentLang === 'zh' && article.title.en && (
                                                <div className="text-xs text-muted-foreground mt-1">
                                                    {article.title.en}
                                                </div>
                                            )}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-foreground">
                                            {formatDate(article.date)}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                            <button
                                                onClick={() => navigate(`/dashboard/articles/${article.id}`)}
                                                className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary/10 hover:bg-primary/20 text-primary rounded-lg transition-colors"
                                            >
                                                <Eye className="h-4 w-4" />
                                                {t('articles.view')}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}
